import { render, staticRenderFns } from "./PublisherSetupTabPta.vue?vue&type=template&id=0a6e81b2"
import script from "./PublisherSetupTabPta.vue?vue&type=script&lang=js"
export * from "./PublisherSetupTabPta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports